(function () {
  'use strict';

  if (window.__ryConversionSafetyPatchLoaded) return;
  window.__ryConversionSafetyPatchLoaded = true;

  function addTag(field, tag) {
    if (!field) return;
    var tags = String(field.value || '')
      .split(',')
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
    if (tags.indexOf(tag) === -1) tags.push(tag);
    field.value = tags.join(',');
  }

  function cleanFinderForms() {
    Array.prototype.slice.call(document.querySelectorAll('input[name="contact[note]"], #RYFinderLeadNote')).forEach(function (field) {
      if (field && field.parentNode) field.parentNode.removeChild(field);
    });

    Array.prototype.slice.call(document.querySelectorAll('#RYFinderLeadForm, #RYTrainingFinderCaptureForm')).forEach(function (form) {
      var tagsField = form.querySelector('input[name="contact[tags]"]');
      addTag(tagsField, 'lead-training-finder');
      if (form.dataset.rySafetyBound === 'true') return;
      form.dataset.rySafetyBound = 'true';
      form.addEventListener('submit', function () {
        addTag(form.querySelector('input[name="contact[tags]"]'), 'lead-training-finder');
      }, true);
    });
  }

  function removeUnusedFinderForm() {
    if (window.location.pathname.indexOf('/pages/find-my-training') === -1) return;
    var globalCapture = document.getElementById('RYFinderLeadCapture');
    var dedicatedCapture = document.getElementById('ry-finder-capture');
    if (globalCapture && dedicatedCapture && globalCapture.parentNode) {
      globalCapture.parentNode.removeChild(globalCapture);
    }
  }

  function patchBeijingActions() {
    if (window.location.pathname.indexOf('/products/beijing-kids-yoga-training-september-2026') === -1) return;
    var registrationUrl = 'https://mp.weixin.qq.com/s/CPKnzGHcmMXnqwqIaT0kdA';
    var sticky = document.querySelector('[data-ry-cro-sticky]');
    if (sticky) {
      var prompt = sticky.querySelector('span');
      var label = sticky.querySelector('strong');
      var action = sticky.querySelector('a');
      if (prompt) prompt.textContent = 'Ready to join Christina in Beijing?';
      if (label) label.textContent = 'Register for Beijing';
      if (action) {
        action.textContent = 'Register';
        action.href = registrationUrl;
        action.target = '_blank';
        action.rel = 'noopener';
      }
    }

    var panel = document.querySelector('[data-ry-cro-product-panel]');
    if (panel) {
      var heading = panel.querySelector('h2');
      var intro = panel.querySelector('.ry-cro-product-panel__head p:not(.ry-cro-kicker)');
      var facts = panel.querySelectorAll('.ry-cro-product-panel__facts span');
      var panelAction = panel.querySelector('.ry-cro-secondary-button');
      if (heading) heading.textContent = 'Beijing · 25–27 September 2026';
      if (intro) intro.textContent = 'Three full days with Christina Lin, 8:00 a.m.–5:30 p.m., with current tuition of ¥5,880 and official registration through WeChat.';
      var factCopy = [
        ['Current tuition', '¥5,880 standard registration'],
        ['Three full days', '25–27 September 2026'],
        ['Trainer', 'Christina Lin'],
        ['Language support', 'Chinese and English support']
      ];
      Array.prototype.forEach.call(facts, function (fact, index) {
        if (!factCopy[index]) return;
        var strong = fact.querySelector('strong');
        var em = fact.querySelector('em');
        if (strong) strong.textContent = factCopy[index][0];
        if (em) em.textContent = factCopy[index][1];
      });
      if (panelAction) {
        panelAction.textContent = 'Register Through WeChat';
        panelAction.href = registrationUrl;
        panelAction.target = '_blank';
        panelAction.rel = 'noopener';
      }
    }
  }

  function init() {
    removeUnusedFinderForm();
    cleanFinderForms();
    patchBeijingActions();
    window.setTimeout(cleanFinderForms, 80);
    window.setTimeout(cleanFinderForms, 500);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('button[data-result], [data-rainbow-quiz] button, [data-ry-chooser] button')) {
      window.setTimeout(cleanFinderForms, 80);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
}());
